import React from "react";
import { Spin, Modal, Button } from "antd";
import { Link, withRouter } from "react-router-dom";
import { IMAGE_BASE_URL, NoImg } from "utilities/constants";
import { languageLable } from "utilities/helpers";
import { connect } from "react-redux";
import { FaWhatsapp } from "react-icons/fa";

class HomeDefaultTopCategories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      mediaBaseURL: null,
      loading: false,
    };
  }

  // Todo: Remove this
  // componentDidMount = () => {
  //   this.props.dispatch({
  //     type: "EMAIL_PHONE_CONFIRMATION_MODAL",
  //     emailPhoneConfirmationModal: true,
  //   });
  // };

  componentDidUpdate = (props) => {
    if (
      props.auth &&
      props.auth.appDefaultSetting &&
      props.auth.appDefaultSetting.ImageUrl &&
      !this.state.mediaBaseURL
    ) {
      this.setState({
        mediaBaseURL: this.props.auth.appDefaultSetting.ImageUrl,
      });
    }
  };

  closeEmailConformationModal = () => {
    this.props.dispatch({
      type: "EMAIL_PHONE_CONFIRMATION_MODAL",
      emailPhoneConfirmationModal: false,
    });
  };

  changeEmailConformationModal = () => {
    this.closeEmailConformationModal();
    this.props.dispatch({
      type: "OPEN_EMAIL_PHONE_OPTION_MODAL",
      openEmailPhoneOptionModal: true,
    });
    this.props.history.push("/account/user-information");
  };

  render() {
    const { categories } = this.props.app;
    const { emailPhoneConfirmationModal, userData } = this.props.auth;
    const { selectedLanguageData } = this.props.app;
      const whatsappChatboatSync = localStorage.getItem("WhatsappChatboatSync");

    return (
      <div className="ps-top-categories">
        <div className="ps-container">
          <h3>{languageLable(selectedLanguageData, "Top Categories")}</h3>
          <Spin spinning={this.state.loading}>
            <div className="row">
              {categories &&
                categories.map((item) => (
                  <div
                    className="col-xl-2 col-lg-3 col-md-4 col-sm-4 col-6 "
                    key={item.Id}
                    >
                        { this.props.auth.isLoggedIn && this.props.auth.isVerified === false ? <Link to={`/account/register-verify-btn`}>
                                <div className="ps-block--category">
                                    {item.MediaId && this.state.mediaBaseURL ? (
                                        <img
                                            src={`${IMAGE_BASE_URL}${this.state.mediaBaseURL}${item.MediaId}`}
                                            alt={item.Name}
                                        />
                                    ) : (
                                        <img src={NoImg} alt={item.Name} />
                                    )}
                                    <p>{languageLable(selectedLanguageData, item.Name)}</p>
                                </div>
                        </Link> : 
                            <Link to={`/search-product/${item.Id}`}>
                                <div className="ps-block--category">
                                    {item.MediaId && this.state.mediaBaseURL ? (
                                        <img
                                            src={`${IMAGE_BASE_URL}${this.state.mediaBaseURL}${item.MediaId}`}
                                            alt={item.Name}
                                        />
                                    ) : (
                                        <img src={NoImg} alt={item.Name} />
                                    )}
                                    <p>{languageLable(selectedLanguageData, item.Name)}</p>
                                </div>
                            </Link>
                            }
                    
                  </div>
                ))}
            </div>
          </Spin>
          {emailPhoneConfirmationModal && (
            <Modal
              title="Confirm"
              open={emailPhoneConfirmationModal}
              onCancel={() => this.closeEmailConformationModal()}
              footer={null}
              centered
              className="email-phone-confirmation-modal"
            >
              <p>
                Your Email id is: <strong> {userData.email} </strong>{" "}
              </p>
              <p>
                and mobile number is: <strong> {userData.mobile} </strong>
              </p>
              <div className="button-container">
                <Button onClick={() => this.closeEmailConformationModal()}>
                  Confirm
                </Button>

                <Button
                  type="primary"
                  onClick={() => this.changeEmailConformationModal()}
                >
                  Change
                </Button>
              </div>
            </Modal>
          )}
                {/* WhatsApp Floating Button */}

                { whatsappChatboatSync && whatsappChatboatSync === 'true' &&  
                    <div style={{
                        position: "fixed",
                        bottom: "60px",
                        right: "30px",
                        zIndex: 1000,
                    }}>
                        <button
                            onClick={() =>
                                window.open(
                                    `https://wa.me/+919998847465?text=${encodeURIComponent("Hello")}`,
                                    "_blank"
                                )
                            }
                            style={{
                                backgroundColor: "#25D366",
                                border: "none",
                                borderRadius: "50%",
                                padding: "15px",
                                boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                                cursor: "pointer",
                            }}
                        >
                            <img
                                src="https://img.icons8.com/ios-filled/50/ffffff/whatsapp--v1.png"
                                alt="WhatsApp"
                                style={{ width: "40px", height: "40px" }}
                            />
                        </button>
                    </div>}
       
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};
export default connect(mapStateToProps)(withRouter(HomeDefaultTopCategories));
